"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentProviderBoxSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        border: "1px solid ".concat(theme.palette.grey[200]),
        borderRadius: theme.spacing(2),
        padding: theme.spacing(4, 3),
        position: 'relative',
        margin: theme.spacing(2)
    };
});
const SkeletonProviderTitle = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(3),
        width: '40%'
    };
});
const SkeletonImage = (0, _mui.styled)(_mui.Skeleton)(()=>({
        width: 35,
        height: 35,
        position: 'absolute',
        right: 15,
        top: 8
    }));
const PaymentProviderBoxSkeleton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonProviderTitle, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonImage, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {})
        ]
    });
exports.PaymentProviderBoxSkeleton = PaymentProviderBoxSkeleton;
